import React from 'react';
import * as R from 'ramda';
import { compose, withHandlers } from 'react-recompose';
// features
import ReferenceFormComponent from '../../../reference/components/reference-form';
// forms
import SelectPrintTemplateForm from '../../../../forms/forms/select-print-template-form';
// helpers/constants
import * as G from '../../../../helpers';
import * as GC from '../../../../constants';
// feature dispatch-report/order
import { RowActions } from '../components/row-actions';
//////////////////////////////////////////////////

export const withPageActionsHandlers = () => compose(
  withHandlers({
    handleClickEditIcon: (props) => (e, data) => (
      props.openFixedPopup({
        position: 'right',
        el: e.currentTarget,
        content: (
          <RowActions
            entity={data}
            openModal={props.openModal}
            openLoader={props.openLoader}
            closeModal={props.closeModal}
            closeLoader={props.closeLoader}
            closeFixedPopup={props.closeFixedPopup}
            cancelCLORequest={props.cancelCLORequest}
            deleteItemRequest={props.deleteItemRequest}
            currentBranchGuid={props.currentBranchGuid}
            getItemListRequest={props.getItemListRequest}
            resetListAndPagination={props.resetListAndPagination}
            changeCancelStatusRequest={props.changeCancelStatusRequest}
            referenceTypeOptions={G.getOptionsFromDataArrayByPath(
              [GC.FIELD_NAME],
              [GC.FIELD_GUID],
              props.cloRefTypes,
            )}
          />
        ),
      })
    ),
    handleAddReferenceList: (props) => () => {
      const {
        itemList,
        openModal,
        createReferenceRequest,
      } = props;

      const isSelected = (item) => item.selected;

      const selectedList = R.map(
        (item) => item.guid,
        R.filter(isSelected, itemList),
      );

      if (R.isEmpty(selectedList)) {
        return G.showToastrMessageSimple(
          'info',
          G.getWindowLocale('messages:select-item', 'Please, select at least one item'),
        );
      }

      const multiAddingEntRef = (values) => {
        const params = R.assoc('primaryObjectGuids', selectedList, values);
        createReferenceRequest(params);
      };

      const component = (
        <ReferenceFormComponent
          scope={GC.REF_SCOPE_NAME_CLO}
          submitAction={(params) => multiAddingEntRef(params)}
        />
      );

      const modal = G.createAddReferenceModalOptions(component);

      openModal(modal);
    },
    handlePrint: ({ openModal, printRequest }) => () => {
      const component = (
        <SelectPrintTemplateForm
          submitAction={(values) => printRequest(values)}
          printableSection={GC.DOCUMENT_PRINTABLE_SECTION_CLO_REPORT}
        />
      );

      const modal = G.getDefaultModalOptions(component, G.getWindowLocale('titles:print-options', 'Print Options'));

      openModal(modal);
    },
  }),
);
